import { useCallback } from "react"
import { getTakenChatRoute } from "@/modules/chats/lib/routing-helpers"
import { useChatRequestTakeOverStore } from "@/modules/chats/stores/useChatRequestTakeOverStore"
import { RequestTakeOverDialog } from "@/modules/common/dialog/request-take-over-dialog"
import { PatientFileLockTakeOverResult } from "@/modules/patients/services/usePatientFileLockChangeSubscription"

export const ChatRequestTakeOverDialog = () => {
  const requestTakeOver = useChatRequestTakeOverStore((state) => state.requestTakeOver)
  const setRequestTakeOver = useChatRequestTakeOverStore((state) => state.setRequestTakeOver)

  const handlePatientFileLockTakeOverEnded = useCallback(
    ({ status, chatThreadId }: PatientFileLockTakeOverResult) => {
      if (status !== "GRANTED" || !chatThreadId) return

      setRequestTakeOver(undefined)

      window.location.href = getTakenChatRoute(chatThreadId)
    },
    [setRequestTakeOver],
  )

  if (requestTakeOver) {
    return (
      <RequestTakeOverDialog
        patientId={requestTakeOver.patientId}
        patientName={requestTakeOver.patientName}
        onPatientFileLockTakeOverEnded={handlePatientFileLockTakeOverEnded}
      />
    )
  }

  return null
}
